export const presentationTypes = {
    loading: "LOADING_PRESENTATION",
    delete: "DELETE_PRESENTATION",
    loadedOne: "LOADED_PRESENTATION",
    loadedMultiple: "LOADED_PRESENTATIONS",
    success: "SUCCESS_PRESENTATION",
    restore: "RESTORE_PRESENTATION",
    hardDelete: "HARDDELETE_PRESENTATION",
};
